import Icon from "@/v2-ui/icon"
import Tooltip from "@/v2-ui/tooltip"
import cn from "@/v2-ui/utils/utils.cn"
import type { LicenseFeatureGroupReachState } from "@/v2-backoffice-client/license/featureGroup/compose/license.featureGroup.lens.utils"

export type LicenseFeatureGroupReachIndicatorProps = {
  state: LicenseFeatureGroupReachState
  /** The answer in full: "Reaches Lina via Placepoint Enterprise. Ends if…". */
  title: string
}

// The mark that leads a row or header through the person lens: the rule's
// answer for that one person, in the footprint of the checkbox it stands
// in for, so the list reads as one column of answers. A tick is "they have
// it", a cross "they don't", a dash on a header "some of what is beneath";
// the why is one hover away. Never a control: a person's access is decided
// on their customer's panel, and the mark says so by not being a box.
function LicenseFeatureGroupReachIndicator(
  props: LicenseFeatureGroupReachIndicatorProps,
) {
  const { state, title } = props
  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <span
          role="img"
          aria-label={title}
          className={cn(
            "flex size-4 shrink-0 cursor-help items-center justify-center",
            state === "all" && "text-primary",
            state === "some" && "text-muted-foreground",
            state === "none" && "text-muted-foreground/60",
          )}
        >
          <Icon
            src={
              state === "all" ? "check" : state === "some" ? "minus" : "cross"
            }
            size={state === "all" ? 14 : 12}
          />
        </span>
      </Tooltip.Trigger>
      <Tooltip.Content side="top" className="max-w-[320px]">
        {title}
      </Tooltip.Content>
    </Tooltip>
  )
}

export default LicenseFeatureGroupReachIndicator
